import React, { memo } from "react";
import { Button, ButtonToolbar, Row, Col } from "reactstrap";
import { reduxForm, formValueSelector, clearFields } from "redux-form";
import PropTypes from "prop-types";
import ConfigurationDropdown from "../../../../IssuerConfiguration/ConfigurationDropdown";
import ConfigView from "../../../../IssuerConfiguration/ViewIssuerConfig/components/ViewIssuerConfig";
import { validateCardConfiguration as validate } from "./Validations/validateCardConfig";
import { connect } from "react-redux";
import { viewIssuerConfig, resetConfigs, getAllIssuerConfigs } from "../../../../IssuerConfiguration/actions/issuerConfig.actions";
import SCPIssuersDropDown from "../../../../Issuers/SCPIssuersDropDown";
import AccessControl from "../../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../../constants/permissions.constants";

let CardConfiguration = memo(({ dispatch, config, handleSubmit, previousPage, configName, submitting, invalid, permissions, assignedIssuer, selectedIssuer }) => {
    let userPermissions = permissions;

    userPermissions = userPermissions && userPermissions.map((permission) => permission.authority);

    const isAdmin = userPermissions && userPermissions.includes(permissionsConstants.FETCH_ISSUER_CONFIGS);

    const issuer = isAdmin ? selectedIssuer : assignedIssuer;

    function fetchConfig(value) {
        if (value && issuer) {
            dispatch(viewIssuerConfig(value.name, issuer.issuerCode));
        }
    }

    const getConfigFromIssuer = (selectedIssuer) => {
        
        dispatch(clearFields("createcard", true, true, "configName"));

        if (selectedIssuer) {
            dispatch(getAllIssuerConfigs(selectedIssuer));
        } else {
            dispatch(resetConfigs());
        }
    };

    return (
        <form className="form wizard__form" onSubmit={handleSubmit}>
            <Row>
                <AccessControl allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]} renderNoAccess={() => null}>
                    <Col lg="3">
                        <SCPIssuersDropDown required id="issuer" label="Select Issuer" onChange={getConfigFromIssuer} />
                    </Col>
                </AccessControl>

                <Col lg="2">
                    <ConfigurationDropdown required disabled={config.loading} id="configName" onChange={fetchConfig} label="Select card configuration" />
                </Col>
            </Row>
            {configName && <ConfigView configId={configName.name} config={config} viewOnly fetchData={fetchConfig} />}

            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                <Button color="primary" type="button" id="prev-customer-information" className="previous" disabled={config.loading} onClick={previousPage}>
                    Back
                </Button>
                <Button disabled={submitting || invalid || config.loading} color="primary" type="submit" id="next-review-cardrequest" className="next">
                    Next
                </Button>
            </ButtonToolbar>
        </form>
    );
});

CardConfiguration.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

CardConfiguration = reduxForm({
    form: "createcard", //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(CardConfiguration);

const selector = formValueSelector("createcard");
CardConfiguration = connect((state) => {
    return {
        configName: selector(state, "configName"),
        selectedIssuer: selector(state, "scpIssuers"),
        config: state.getIssuerConfig,
        permissions: state.permissions && state.permissions.response,
        assignedIssuer: state.getIssuerDomainMapping && state.getIssuerDomainMapping.response && state.getIssuerDomainMapping.response.data ? state.getIssuerDomainMapping.response.data[0] : [],
    };
})(CardConfiguration);

export default CardConfiguration;
